import { cx } from "@linaria/core";
import React, { forwardRef } from "react";
import {
  Styles,
  CloseButton,
  Title,
  BodyContentWrapper,
  TitleContentWrapper
} from "./Content.styles";
import { InfoIcon, CloseIcon } from "../../icons";
const displayConfiguration = {
  width: 250,
  arrowOffsetX: 0,
  arrowOffsetY: 0,
  contentOffsetX: 0,
  contentOffsetY: 0,
  color: ""
};
const Content = forwardRef(({
  classNames,
  title,
  content,
  hoverCallback,
  persist,
  direction,
  showArrow,
  showIcon,
  closeCallback,
  ...rest
}, ref) => /* @__PURE__ */ React.createElement(Styles, {
  role: "tooltip",
  className: cx(`${direction.split("-")[0]}-arrow`, classNames?.tooltip),
  direction,
  showArrow,
  top: rest.top,
  left: rest.left,
  width: rest.width,
  color: rest.color,
  arrowOffsetX: rest.arrowOffsetX,
  arrowOffsetY: rest.arrowOffsetY,
  ref,
  onMouseEnter: hoverCallback
}, /* @__PURE__ */ React.createElement(TitleContentWrapper, null, showIcon && /* @__PURE__ */ React.createElement(InfoIcon, {
  className: "info-icon"
}), title && /* @__PURE__ */ React.createElement(Title, null, title), persist && /* @__PURE__ */ React.createElement(CloseButton, {
  "aria-label": "close",
  type: "button",
  name: "close",
  onClick: closeCallback
}, /* @__PURE__ */ React.createElement(CloseIcon, null))), content && /* @__PURE__ */ React.createElement(BodyContentWrapper, null, content)));
Content.defaultProps = {
  ...displayConfiguration,
  persist: false
};
export default Content;
export { displayConfiguration };
